import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../../services/translate/translate-config.service';

@Component({
  selector: 'app-through-option',
  templateUrl: './through-option.page.html',
  styleUrls: ['./through-option.page.scss'],
})
export class ThroughOptionPage implements OnInit {
  privacyPolicy: string;
  option: string;
  language: string;
  public screenWidth;

  @Input() canFillPreviousCredential = false;

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private translate: TranslateService,
    private platform: Platform,
    public translateConfigSvc: TranslateConfigService,
    private route: ActivatedRoute
  ) {
    this.option = this.route.snapshot.paramMap.get('option');
    platform.ready().then(() => {
      this.screenWidth = platform.width();
    });
  }

  async ngOnInit() {
    this.language = await this.translateConfigSvc.getLanguage();
  }

  async closeModal() {
    await this.modalCtrl.dismiss();
  }

  async routeTo(option) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        throughOption: option,
        canFillPreviousCredential: this.canFillPreviousCredential,
      },
    };
    await this.closeModal();
    const route = this.option === 'login' ? 'signin' : /* istanbul ignore next */ 'register';
    this.router.navigate([route], navigationExtras);
  }
}
